import React from 'react'
import ContentLoader from 'react-content-loader'

const ToggleBarLoader = () => {
    return (
        <ContentLoader
            height={'44px'}
            width={'150px'}
            style={{
                marginRight: '28px',
            }}
        >
            <rect width={'150px'} rx={'24px'} ry={'24px'} height={'44px'} />
        </ContentLoader>
    )
}

export default ToggleBarLoader
